import { theme } from 'src/theme/mui-theme';
import { Box, Button, Typography } from "@mui/material";
import Paper from "@mui/material/Paper";
import { useState } from "react";
import { QuestionData } from './QuestionData';
import { ProgressIndicator } from "./ProgressIndicator";
import { QuestionStep } from './QuestionStep';
import { BackIcon } from "src/icons/quote/BackIcon";
import { UplanIcon } from "src/icons/quote/UplanIcon";
import { useSubmitAnswersMutation } from "src/api/v2/zoho-v2-ApiSlice";
import { getFrontendURL } from "src/utils/url";

export const ProfileCompletionPage = (props: {}) => {

    const questionSteps = new QuestionData().questionSteps

    const [step, setStep] = useState(0);
    const [answers, setAnswers] = useState<string[][]>([[], [], []]);

    const [submitAnswers] = useSubmitAnswersMutation();

    const handleOptionToggle = (optionValue: string) => {
        setAnswers((prev) => {
            const updated = [...prev];
            const current = updated[step];

            if (step === 0) {
                updated[step] = current.includes(optionValue) ? [] : [optionValue];
            } else {
                updated[step] = current.includes(optionValue)
                    ? current.filter((val) => val !== optionValue)
                    : [...current, optionValue];
            }

            return updated;
        });
    };

    const handleNext = async () => {
        if (step < questionSteps.length - 1) {
            setStep(step + 1);
        } else {
            const payload = questionSteps.map((q, i) => ({
                question: q.key,
                answers: answers[i] || [],
            }));

            const searchParams = new URLSearchParams(window.location.search);
            const userId = searchParams.get("userId");

            try {
                if (userId) {
                    await submitAnswers({ body: { responses: payload }, userId }).unwrap();


                    window.location.href = getFrontendURL()+"/site/signup-success";
                }
            } catch (error) {

                console.error("Submission failed", error);
            }
        }
    };

    return (
        <Box
            sx={{
                width: '100vw',
                height: '100vh',
                backgroundColor: theme.palette.primary.main,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: 0,
            }}
        >
            <Paper
                elevation={3}
                sx={{
                    width: '450px',
                    backgroundColor: 'white',
                    borderRadius: 4,
                    paddingTop: step === 0 ? 6 : 4,
                    paddingX: 6,
                    paddingBottom: 6,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                }}
            >

                {step > 0 && (
                    <Box display="flex" alignItems="center" gap={1} mb={2} ml={-3} style={{ cursor: 'pointer' }} onClick={() => setStep(Math.max(0, step - 1))}>
                        <BackIcon style={{ width: '13px' }}/>
                        <Typography variant="body2" color={theme.palette.primary.main}>Back</Typography>
                    </Box>
                )}

                <UplanIcon style={{ marginInline: 'auto', width: '100px', scale: '1.5' }}/>

                <QuestionStep
                    question={questionSteps[step].question}
                    options={questionSteps[step].options}
                    selected={answers[step]}
                    onSelect={handleOptionToggle}
                    step={step}
                />

                <Button
                    variant="contained"
                    disabled={answers[step].length === 0}
                    fullWidth
                    sx={{ mt: 5, height: '48px', boxShadow: 'none' }}
                    onClick={handleNext}
                >
                    {step === questionSteps.length - 1 ? 'Submit' : 'Next'}
                </Button>

                <ProgressIndicator total={questionSteps.length} current={step + 1} />
            </Paper>
        </Box>
    );
}